import { ApplicationController } from "../application_controller"

export default class extends ApplicationController {
	initialize() {

		var window_height = $(window).height()
		$(".launchpad-page").css("min-height", window_height)
	}
}